export default "__VITE_PUBLIC_ASSET__91e4d6a2__"